import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PipelinesService} from "../../../../pipelines.service";
import {CurrencyPipe, PercentPipe} from "@angular/common";

@Component({
  selector: 'pipelines-panel-esg',
  imports: [
    PercentPipe,
    CurrencyPipe
  ],
  templateUrl: './pipelines-panel-esg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pipelines-panel-esg.component.scss','../../pipelines-table.component.scss']
})
export class PipelinesPanelEsgComponent implements OnInit{
  constructor(private _pipelineService:PipelinesService) {
  }
  @Input() detail:any;
  public expanded:boolean = false;
  public unitSetAsides:any[] = []
  public economicRows: { label: string; key: string }[][] = [];

  public displayFields: { label: string; key: string }[] = [
    { label: 'LIHTC Units', key: 'total_lihtc_units'},
    { label: 'Jobs Created', key: 'jobs_created'},
    { label: 'Taxes Saved - First Year', key: 'taxes_saved_first_year'},
    { label: 'Taxes Saved - Annual', key: 'taxes_saved_annually'},
    { label: 'Local Income Generated - First Year', key: 'local_income_first_year'},
    { label: 'Local Income Generated - Annual', key: 'local_income_annually'}
  ]

  ngOnInit() {
    this.unitSetAsides = this._pipelineService.parseField(this.detail.unit_set_asides)
    this.economicRows = this._pipelineService.splitExpandedRowChunk(this.displayFields, 2)
  }

  public toggleExpand(){
    this.expanded = !this.expanded
  }
}
